<script lang="ts">
  import 'simplebar';
  import 'simplebar/dist/simplebar.css';

  import TopActivityItem from './TopActivityItem.svelte';
  import { onMount, tick } from 'svelte';
  import { findTopActivity, type TopActivitiesItem } from '$src/utils/api/topActivities.util';
  import SimpleBar from 'simplebar';
  import { range } from 'lodash-es';
  import SkeletonTopActivityItem from '$lib/components/common/skeletons/SkeletonTopActivityItem.svelte';
  import { fade } from 'svelte/transition';

  let topActivities: TopActivitiesItem[] = [];
  let loading = true;
  let container: HTMLElement;

  onMount(async () => {
    topActivities = (await findTopActivity()) || [];

    loading = false;

    await tick();

    if(!container) return;
		new SimpleBar(container);
	});
</script>

<div class="--updated-border shadow-island pt-4 rounded-2xl w-full h-[350px] bg-color-slate-white overflow-auto scrollbar-hide">
  <div class="font-bold whitespace-nowrap px-4 text-lg text-blueish-grey-900 font-switzer">
    Top Activity
  </div>

  <!-- Separator -->
  <div class="border-neutral-800 border-b-[1px] border-opacity-5 mt-4" />

  <!-- Scroll area -->
  <div class="pr-1 scrollbar-hide">
    <div bind:this={container} class="--top-activity-scroll-area overflow-y-scroll scrollbar-hide">
      {#if loading}
        {#each range(5) as _}
          <SkeletonTopActivityItem />
        {/each}
      {:else}
        {#each topActivities as activity}
          <span in:fade|global>
            <TopActivityItem {activity} />
          </span>
        {:else}
          <div in:fade|global class="font-semibold text-gray-500 text-center mt-4">
            No activities to show.
          </div>
        {/each}

        {#if topActivities.length}
          <div in:fade|global class="font-semibold text-gray-500 text-center mt-4 mb-5">
            No more activities to show.
          </div>
        {/if}
      {/if}
    </div>
  </div>
</div>
